var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.684 8.465 1.437 1.86c.16.207.559.207.718 0l1.438-1.86c.16-.207-.04-.465-.36-.465h-.974a6.684 6.684 0 0 0-1.507-4.23A6.633 6.633 0 0 0 8.6 1.461a6.614 6.614 0 0 0-4.425.66 6.657 6.657 0 0 0-3.004 3.327 6.693 6.693 0 0 0-.22 4.487 6.664 6.664 0 0 0 2.665 3.608 6.617 6.617 0 0 0 8.383-.83l-.655-.657a5.693 5.693 0 0 1-7.213.713 5.734 5.734 0 0 1-2.293-3.104 5.76 5.76 0 0 1 .19-3.86A5.728 5.728 0 0 1 4.611 2.94a5.691 5.691 0 0 1 7.108 1.42A5.751 5.751 0 0 1 13.017 8h-.974c-.32 0-.52.258-.36.465z",
    fill: "#1E90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.334 4c.184 0 .333.15.333.333v4.334a.333.333 0 0 1-.533.266l-2.667-2a.333.333 0 1 1 .4-.533L7.001 8V4.333C7 4.15 7.15 4 7.334 4z",
    fill: "#1E90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemind);
export default __webpack_public_path__ + "static/media/remind.05c97ba59e93b0a33f786fd5c50c67cd.svg";
export { ForwardRef as ReactComponent };